/* Mono · JavaScript du thème. Vanilla, sans dépendance. */
(function () {
  'use strict';

  var T = window.MonoTheme || { strings: {}, routes: {} };

  /* Formatage monétaire selon shop.money_format ------------------------------ */
  function formatMoney(cents) {
    var format = T.moneyFormat || '{{amount}}';
    cents = parseInt(cents, 10) || 0;
    function group(value, decimals, thousands, separator) {
      var fixed = (value / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + separator + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, ',', '.');
      }
    });
  }

  function savingPercent(variant) {
    if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) return 0;
    return Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
  }

  /* Produit ---------------------------------------------------------------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var packIndex = parseInt(root.getAttribute('data-pack-position'), 10) - 1;
    var inputs = Array.prototype.slice.call(root.querySelectorAll('input[data-option-position]'));
    var idInput = root.querySelector('[data-variant-id]');
    var current = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];

    function selectedOptions() {
      var opts = current ? current.options.slice() : [];
      inputs.forEach(function (input) {
        if (input.checked) opts[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function syncInputs(variant) {
      inputs.forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        input.checked = variant.options[i] === input.value;
      });
    }

    function onChange(event) {
      var changed = parseInt(event.target.getAttribute('data-option-position'), 10) - 1;
      var opts = selectedOptions();
      var variant = findVariant(opts);
      if (!variant) {
        variant = variants.find(function (v) { return v.options[changed] === opts[changed] && v.available; }) ||
          variants.find(function (v) { return v.options[changed] === opts[changed]; });
        if (variant) syncInputs(variant);
      }
      if (variant) update(variant);
    }

    function update(variant) {
      current = variant;
      if (idInput) idInput.value = variant.id;

      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
      var pct = savingPercent(variant);
      root.querySelectorAll('[data-compare]').forEach(function (el) {
        el.textContent = formatMoney(variant.compare_at_price);
        el.hidden = pct === 0;
      });
      root.querySelectorAll('[data-discount]').forEach(function (el) {
        el.textContent = '\u2212' + pct + ' %';
        el.hidden = pct === 0;
      });
      root.querySelectorAll('[data-cta-price]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
      root.querySelectorAll('[data-cta]').forEach(function (btn) {
        btn.disabled = !variant.available;
        var label = btn.querySelector('[data-cta-label]');
        if (label && !variant.available) label.textContent = T.strings.epuise;
        if (label && variant.available && label.getAttribute('data-default')) label.textContent = label.getAttribute('data-default');
      });
      root.querySelectorAll('[data-option-label]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-option-label'), 10) - 1;
        el.textContent = variant.options[i];
      });

      // Cartes de pack : prix de chaque pack dans la finition choisie.
      if (packIndex >= 0) {
        root.querySelectorAll('[data-pack-card]').forEach(function (card) {
          var opts = variant.options.slice();
          opts[packIndex] = card.getAttribute('data-value');
          var match = findVariant(opts);
          var input = card.querySelector('input');
          card.classList.toggle('is-selected', !!(input && input.checked));
          var priceEl = card.querySelector('[data-pack-price]');
          var noteEl = card.querySelector('[data-pack-note]');
          if (priceEl) priceEl.textContent = match ? formatMoney(match.price) : T.strings.indisponible;
          if (noteEl) {
            var p = savingPercent(match);
            noteEl.classList.toggle('pack__note--save', p > 0);
            noteEl.textContent = p > 0 ? T.strings.economie.replace('[p]', p) : (noteEl.getAttribute('data-mention') || '');
          }
        });
      }

      // Galerie : afficher le média de la variante.
      if (variant.featured_media && variant.featured_media.id) {
        var gallery = root.querySelector('[data-gallery]');
        if (gallery) goToMedia(gallery, String(variant.featured_media.id));
      }

      if (root.hasAttribute('data-update-url') && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(new CustomEvent('mono:variant', { detail: { variant: variant, variants: variants } }));
    }

    root.querySelectorAll('[data-cta-label]').forEach(function (el) {
      if (current && current.available) el.setAttribute('data-default', el.textContent.trim());
    });
    inputs.forEach(function (input) { input.addEventListener('change', onChange); });

    initGallery(root.querySelector('[data-gallery]'));
    initSticky(root);
  }

  /* Galerie ----------------------------------------------------------------- */
  function slidesOf(gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    return track ? Array.prototype.slice.call(track.children) : [];
  }

  function goToIndex(gallery, index) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = slidesOf(gallery);
    if (!track || !slides.length) return;
    index = Math.max(0, Math.min(slides.length - 1, index));
    track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    setActive(gallery, index);
  }

  function goToMedia(gallery, mediaId) {
    var slides = slidesOf(gallery);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-media-id') === mediaId) return goToIndex(gallery, i);
    }
  }

  function setActive(gallery, index) {
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var last = thumbs.length - 1;
    thumbs.forEach(function (thumb, i) {
      var active = i === index || (i === last && thumb.hasAttribute('data-thumb-more') && index >= last);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
    var count = slidesOf(gallery).length;
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= count - 1;
    gallery.setAttribute('data-current', index);
  }

  function initGallery(gallery) {
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToIndex(gallery, parseInt(thumb.getAttribute('data-index'), 10) || 0);
      });
    });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var current = function () { return parseInt(gallery.getAttribute('data-current'), 10) || 0; };
    if (prev) prev.addEventListener('click', function () { goToIndex(gallery, current() - 1); });
    if (next) next.addEventListener('click', function () { goToIndex(gallery, current() + 1); });
    setActive(gallery, 0);
    if (!track) return;
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        var slide = track.children[index];
        if (!slide) return;
        setActive(gallery, index);
        track.querySelectorAll('video').forEach(function (video) {
          if (!slide.contains(video)) video.pause();
        });
      }, 120);
    }, { passive: true });
  }

  /* Barre d'achat collante --------------------------------------------------- */
  function initSticky(root) {
    var bar = root.querySelector('[data-sticky]');
    var mainCta = root.querySelector('.buy-form [data-cta]');
    if (!bar || !mainCta || !('IntersectionObserver' in window)) return;
    document.body.classList.add('has-sticky-buy');
    var footer = document.querySelector('.site-footer');
    var finalCta = document.querySelector('.final__btn');
    var ctaVisible = true;
    var footerVisible = false;
    var finalVisible = false;
    var early = bar.hasAttribute('data-sticky-early');
    function render() {
      var passed = mainCta.getBoundingClientRect().top < 0;
      var show = !ctaVisible && !footerVisible && !finalVisible && (early || passed);
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = bar.querySelector('button');
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      ctaVisible = entries[0].isIntersecting;
      render();
    }).observe(mainCta);
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        render();
      }).observe(footer);
    }
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        render();
      }).observe(finalCta);
    }
  }

  /* Heure limite d'expédition ------------------------------------------------ */
  function initCutoff(el) {
    var match = /^(\d{1,2}):(\d{2})$/.exec((el.getAttribute('data-heure') || '').trim());
    if (!match) return;
    var offsetMatch = /^([+-])(\d{2})(\d{2})$/.exec(el.getAttribute('data-offset') || '+0000');
    var offsetMin = offsetMatch ? (offsetMatch[1] === '-' ? -1 : 1) * (parseInt(offsetMatch[2], 10) * 60 + parseInt(offsetMatch[3], 10)) : 0;
    var lastDay = el.getAttribute('data-jours') === 'lun-sam' ? 6 : 5;
    var text = el.querySelector('[data-cutoff-text]');

    function compute() {
      var now = new Date(Date.now() + offsetMin * 60000);
      var day = now.getUTCDay();
      var minutes = now.getUTCHours() * 60 + now.getUTCMinutes();
      var limit = parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
      var workday = day >= 1 && day <= lastDay;
      if (workday && minutes < limit) {
        text.textContent = T.strings.expeditionAujourdhui.replace('[h]', match[1].padStart(2, '0') + ':' + match[2]);
      } else {
        var next = day + 1;
        var tomorrowIsWorkday = next >= 1 && next <= lastDay;
        text.textContent = T.strings.expeditionProchain.replace('[j]', tomorrowIsWorkday ? T.strings.demain : T.strings.lundi);
      }
      el.hidden = false;
    }
    compute();
    setInterval(compute, 60000);
  }

  /* Date de livraison estimée ------------------------------------------------ */
  function shopNow(offsetAttr) {
    var m = /^([+-])(\d{2})(\d{2})$/.exec(offsetAttr || '+0000');
    var offsetMin = m ? (m[1] === '-' ? -1 : 1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10)) : 0;
    return new Date(Date.now() + offsetMin * 60000);
  }

  function addWorkingDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setUTCDate(d.getUTCDate() + 1);
      var wd = d.getUTCDay();
      if (wd >= 1 && wd <= 5) added++;
    }
    return d;
  }

  function initDeliveryEstimate(el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var text = el.querySelector('[data-delivery-text]');
    if (isNaN(min) || isNaN(max) || !text || !T.strings.livraisonEstimee) return;
    if (max < min) { var tmp = max; max = min; min = tmp; }
    var lastDay = el.getAttribute('data-jours') === 'lun-sam' ? 6 : 5;
    var now = shopNow(el.getAttribute('data-offset'));
    var cutoff = /^(\d{1,2}):(\d{2})$/.exec((el.getAttribute('data-heure') || '').trim());
    var limit = cutoff ? parseInt(cutoff[1], 10) * 60 + parseInt(cutoff[2], 10) : 24 * 60;
    var ship = new Date(now.getTime());
    var isShipDay = function (d) { var wd = d.getUTCDay(); return wd >= 1 && wd <= lastDay; };
    if (!isShipDay(ship) || now.getUTCHours() * 60 + now.getUTCMinutes() >= limit) {
      do { ship.setUTCDate(ship.getUTCDate() + 1); } while (!isShipDay(ship));
    }
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    } catch (e) { return; }
    var parts = T.strings.livraisonEstimee.split(/\[debut\]|\[fin\]/);
    var start = fmt.format(addWorkingDays(ship, min));
    var end = fmt.format(addWorkingDays(ship, max));
    text.textContent = '';
    var pieces = [parts[0] || '', start, parts[1] || '', end, parts[2] || ''];
    pieces.forEach(function (piece, i) {
      if (!piece) return;
      if (i === 1 || i === 3) {
        var strong = document.createElement('strong');
        strong.textContent = piece;
        text.appendChild(strong);
      } else {
        text.appendChild(document.createTextNode(piece));
      }
    });
    el.hidden = false;
  }

  /* Sommaire des pages légales --------------------------------------------- */
  function initToc(nav) {
    var source = document.querySelector('[data-toc-source]');
    var list = nav.querySelector('ol');
    if (!source || !list) return;
    var headings = source.querySelectorAll('h2');
    if (headings.length < 3) return;
    headings.forEach(function (h, i) {
      if (!h.id) {
        var slug = h.textContent.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        h.id = (slug || 'section') + '-' + (i + 1);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    nav.hidden = false;
  }

  /* Kit ----------------------------------------------------------------------- */
  function initKit(section) {
    var packIndex = parseInt(section.getAttribute('data-pack-index'), 10);
    var kitValue = section.getAttribute('data-kit-value');
    document.addEventListener('mono:variant', function (event) {
      var opts = event.detail.variant.options.slice();
      opts[packIndex] = kitValue;
      var kit = event.detail.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!kit) return;
      var input = section.querySelector('[data-kit-variant]');
      if (input) input.value = kit.id;
      var price = section.querySelector('[data-kit-price]');
      if (price) price.textContent = formatMoney(kit.price);
      var compare = section.querySelector('[data-kit-compare]');
      var save = section.querySelector('[data-kit-save]');
      var eco = kit.compare_at_price && kit.compare_at_price > kit.price ? kit.compare_at_price - kit.price : 0;
      if (compare) { compare.textContent = formatMoney(kit.compare_at_price); compare.hidden = eco === 0; }
      if (save) { save.textContent = '\u2212' + formatMoney(eco); save.hidden = eco === 0; }
      var cta = section.querySelector('[data-kit-cta]');
      if (cta) cta.disabled = !kit.available;
    });
  }

  /* Panier tiroir ----------------------------------------------------------- */
  var drawer = null;
  var lastFocus = null;

  function drawerEl() {
    if (!drawer) drawer = document.querySelector('[data-drawer]');
    return drawer;
  }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = d.querySelector('.drawer__panel');
    if (panel) setTimeout(function () { panel.focus(); }, 50);
    return true;
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderDrawer(sections) {
    var d = drawerEl();
    if (!d || !sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('[data-drawer-content]');
    var current = d.querySelector('[data-drawer-content]');
    if (fresh && current) {
      current.replaceWith(fresh);
      fresh.querySelectorAll('[data-delivery-estimate]').forEach(initDeliveryEstimate);
      var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }
  }

  var flashTimer;
  function showFlash() {
    var d = drawerEl();
    var flash = d && d.querySelector('[data-drawer-flash]');
    if (!flash) return;
    clearTimeout(flashTimer);
    flash.classList.remove('is-leaving');
    flash.hidden = false;
    flashTimer = setTimeout(function () {
      flash.classList.add('is-leaving');
      setTimeout(function () { flash.hidden = true; flash.classList.remove('is-leaving'); }, 400);
    }, 2600);
  }

  function sectionsUrl() {
    return window.location.pathname;
  }

  function addToCart(form) {
    var error = form.querySelector('[data-error]');
    if (error) error.hidden = true;
    var targets = form.id
      ? document.querySelectorAll('button[form="' + form.id + '"], #' + CSS.escape(form.id) + ' button[type="submit"]')
      : form.querySelectorAll('button[type="submit"]');
    targets.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', sectionsUrl());

    fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok || result.json.status) {
          var message = result.json.description || result.json.message || 'Erreur';
          if (error) { error.textContent = message; error.hidden = false; }
          return;
        }
        if (result.json.sections) renderDrawer(result.json.sections);
        if (!openDrawer()) { window.location.href = T.routes.cart; return; }
        showFlash();
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        targets.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      });
  }

  function changeLine(button) {
    var d = drawerEl();
    var content = d && d.querySelector('[data-drawer-content]');
    if (content) content.classList.add('is-loading');
    fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: button.getAttribute('data-line-change'),
        quantity: parseInt(button.getAttribute('data-quantity'), 10),
        sections: ['cart-drawer'],
        sections_url: sectionsUrl()
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) { renderDrawer(json.sections); })
      .catch(function () { window.location.href = T.routes.cart; })
      .finally(function () {
        var c = drawerEl() && drawerEl().querySelector('[data-drawer-content]');
        if (c) c.classList.remove('is-loading');
      });
  }

  /* Délégation d'événements ----------------------------------------------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    if (!drawerEl()) return;
    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-open]');
    if (opener && drawerEl()) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }
    var line = event.target.closest('[data-line-change]');
    if (line) changeLine(line);
  });

  document.addEventListener('keydown', function (event) {
    var d = drawerEl();
    if (!d || !d.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeDrawer();
    if (event.key === 'Tab') {
      var focusables = d.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  /* Initialisation ----------------------------------------------------------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-cutoff]').forEach(initCutoff);
    (scope || document).querySelectorAll('[data-kit]').forEach(initKit);
    (scope || document).querySelectorAll('[data-delivery-estimate]').forEach(initDeliveryEstimate);
    (scope || document).querySelectorAll('[data-toc]').forEach(initToc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Éditeur de thème : réinitialiser une section rechargée.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
